import shuffle from "seneca-common/utils/functions/random/shuffle";

import { Content } from "../types";

export function generateContent(source: Content): Content {
  return { ...source, images: shuffle(source.images) };
}
